module.exports = [{
      plugin: require('/home/jynt/jyntran/blog.jyntran.ca/prod/node_modules/gatsby-remark-images/gatsby-browser'),
      options: {"plugins":[],"maxWidth":1000,"linkImagesToOriginal":true},
    },{
      plugin: require('/home/jynt/jyntran/blog.jyntran.ca/prod/node_modules/gatsby-plugin-glamor/gatsby-browser'),
      options: {"plugins":[]},
    }]
